import reducers from './ekgRecordingReducers';

export default reducers;



// WEBPACK FOOTER //
// ./src/state/reducers/ekgRecordings/index.js